import React from 'react';

const DataContext = React.createContext(null);

export default DataContext;
